<template>
    <DataTable :value="equipments" class="p-datatable-sm">
        <template #empty>
            No equipment using user defined sound power in this project.
        </template>
        <Column field="pme" header="Equipment" frozen style="max-width:250px" v-if="mode == 'pme' || mode == 'all'">
        </Column>
        <Column field="defaultNoisePower" header="Default Sound Power" style="max-width:80px"
            v-if="mode == 'pme' || mode == 'all'">
        </Column>
        <Column field="noisePower" header="User Defined Sound Power" style="max-width:80px"
            v-if="mode == 'pme' || mode == 'all'">
        </Column>
        <Column field="qpmename" header="Quieter Construction Method/ QPME" style="max-width:250px"
            v-if="mode == 'qpme' || mode == 'all'">
        </Column>
        <Column field="qpmeDefaultNoisePower" header="Default Sound Power" style="max-width:80px"
            v-if="mode == 'qpme' || mode == 'all'">
        </Column>
        <Column field="qpmeNoisePower" header="User Defined Sound Power" style="max-width:80px"
            v-if="mode == 'qpme' || mode == 'all'">
        </Column>
        <Column field="custommethodname" header="Custom Method" style="max-width:250px"
            v-if="mode == 'qpme' || mode == 'all'">
        </Column>
        <Column field="custommethoddba" header="Custom Method dB(A)" style="max-width:80px"
            v-if="mode == 'qpme' || mode == 'all'">
        </Column>
        <Column header="Support Materials">
            <template #body="slotProps">
                <UploadFile format="*" :id="`selectSupportMaterial${slotProps.data.projectPMEId}`" multiple="multiple"
                    @upload="uploadSupportMaterials" :object="slotProps.data" label="Upload Support Materials"
                    :files="slotProps.data.supportMaterials" :endpoint="`${fileEndpoint}${project.guid}`" preview
                    :disabled="project.readonly">
                </UploadFile>
            </template>
        </Column>
    </DataTable>
</template>
<script>
import UploadFile from '@/components/UploadFile.vue';
export default {
    components: {
        UploadFile
    },
    name: 'SupportMaterialTable',
    props: {
        equipments: Array,
        project: Object,
        mode: String,
    },
    methods: {
        uploadSupportMaterials(data) {
            let files = data.files;
            if (!files) return;
            let equipment = data.object;
            let props = this;
            console.log(data);
            for (var i = 0; i < files.length; i++) {
                let file = files[i];
                console.log(file);
                let supportMaterial = {
                    filename: file.name,
                    projectId: props.project.id,
                    projectPMEId: equipment.projectPMEId,
                    progress: 0
                }
                console.log(equipment);
                equipment.supportMaterials.push(supportMaterial);
                let index = equipment.supportMaterials.indexOf(supportMaterial);
                var formData = new FormData();
                formData.append('file', file);

                props.axios({
                    method: "post",
                    url: `${props.apiEndpoint}file?guid=${props.project.guid}&id=${props.project.id}&pmeId=${equipment.projectPMEId}`,
                    data: formData,
                    onUploadProgress: progressEvent => { equipment.supportMaterials[index].progress = Math.round(progressEvent.loaded * 100 / progressEvent.total); console.log(supportMaterial.progress) }
                })
                    .then(function (response) {
                        console.log(response.data);
                        equipment.supportMaterials[index].progress = 100;
                        props.project.equipments.filter(e => e.pme === equipment.pme && e.otherName === equipment.otherName && e.noisePower === equipment.noisePower).forEach(e => {
                            if (e.supportMaterials.filter(s => s.filename === supportMaterial.filename).length === 0) {
                                e.supportMaterials.push(supportMaterial)
                            }
                        })

                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    }
}
</script>
<style scoped>
.center {
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
</style>
